<template src="./project-management-archive.html"></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage'
import HighlightButton from '@/components/misc/HighlightButton.vue'
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import { hasAdminClaim, hasProjectManageClaim, hasMeiClaim } from '@/router/auth'
import dataTablesStore from '@/store/data-tables-store'
import FileSaver from 'file-saver'

export default {
  components: {
    ContextPage,
    Tabulator,
    HighlightButton
  },
  mixins: [tabulatorMixin],
  data () {
    return {
      data: [],
      pageLoader: false,
      help: {
        list: Vue.$helpConfig.projectList
      },
      projectStatus: {
        ACTIVE: 'pending',
        FINISHED: 'finished',
        ARCHIVED: 'archived'
      },
      tabulatorOptions: {
        columns: [
          { title: '', field: 'id', visible: false, headerSort: false },
          {
            title: this.$t('projects.officalProposerOrganization'),
            field: 'organizationName',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('projects.number'),
            field: 'number',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          // {
          //   title: this.$t('projects.code'),
          //   field: 'code',
          //   headerSort: true,
          //   headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
          //   headerFilter: this.vTextFieldFilter,
          //   headerFilterLiveFilter: false,
          //   hozAlign: 'center'
          // },
          {
            title: this.$t('projects.name'),
            field: 'nameFormJson',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center'
          },
          {
            title: this.$t('projects.createdDate'),
            hozAlign: 'center',
            field: 'createdDate',
            tooltip: (cell) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('general.undefined')
            },
            sorter: 'date',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('general.undefined')
            },
            headerFilter: this.vDateRange,
            headerFilterParams: { isRange: true },
            headerFilterLiveFilter: false
          },
          {
            title: this.$t('projects.important'),
            field: 'important',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            width: 150,
            formatter: (cell) => {
              const important = cell.getValue()
              return important === true || important === 'true' ? this.$t('bool.yes') : this.$t('bool.no')
            },
            headerFilterParams: {
              values: [
                { text: this.$t('projects.importantFilter.0'), value: 'true' },
                { text: this.$t('projects.importantFilter.1'), value: 'false' }
              ]
            }
          },
          {
            title: this.$t('projects.foreignFunds'),
            field: 'foreignFunds',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            width: 150,
            formatter: (cell) => {
              const foreignFunds = cell.getValue()
              return foreignFunds === true || foreignFunds === 'true' ? this.$t('bool.yes') : this.$t('bool.no')
            },
            headerFilterParams: {
              values: [
                { text: this.$t('projects.EUFilter.0'), value: 'true' },
                { text: this.$t('projects.EUFilter.1'), value: 'false' }
              ]
            }
          },
          {
            title: this.$t('projects.phase'),
            field: 'stage',
            headerSort: true,
            headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            // formatter: (cell) => {
            //   const phasePreparation = [0, 1, 2, 3]
            //   const phaseValue = cell.getValue()
            //   return phasePreparation.includes(phaseValue) ? this.$t('projects.phasePreparation') : this.$t('projects.phaseRealization')
            // }
            formatter: (cell) => {
              const phaseType = cell.getValue()
              return phaseType === 1 ? this.$t('projects.phasePreparation') : this.$t('projects.phaseRealization')
            },
            headerFilterParams: {
              values: [
                { text: this.$t('projects.phasePreparation'), value: 1 },
                { text: this.$t('projects.phaseRealization'), value: 2 }
              ]
            }
          },
          {
            title: this.$t('projects.stage'),
            hozAlign: 'center',
            field: 'phase',
            tooltip: (cell) => {
              const phase = cell.getValue()
              return this.$t('projects.stages.' + phase)
            },
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            formatter: (cell) => {
              const phase = cell.getValue()
              return this.$t('projects.stages.' + phase)
            },
            headerFilterEmptyCheck: (value) => {
              return value === '0'
            },
            headerFilterParams: {
              values: [
                { text: this.$t('projects.stages.0'), value: 0 },
                { text: this.$t('projects.stages.1'), value: 1 },
                { text: this.$t('projects.stages.2'), value: 2 },
                { text: this.$t('projects.stages.3'), value: 3 },
                { text: this.$t('projects.stages.4'), value: 4 },
                { text: this.$t('projects.stages.5'), value: 5 },
                { text: this.$t('projects.stages.6'), value: 6 },
                { text: this.$t('projects.stages.7'), value: 7 },
                { text: this.$t('projects.stages.8'), value: 8 },
                { text: this.$t('projects.stages.11'), value: 11 },
                { text: this.$t('projects.stages.12'), value: 12 }
              ]
            }
          },
          {
            title: this.$t('projects.phаseStatus'),
            hozAlign: 'center',
            field: 'phaseStatus',
            tooltip: (cell) => {
              const status = cell.getValue()
              const data = ('getData' in cell) ? cell.getData() : {}
              const isOnList = this.isOnList(data)
              return this.$t('projects.phaseStatuses.' + status) + ' ' + (isOnList ? '' : ' ' + this.$t('projects.notOnList'))
            },
            headerFilter: this.vTextSelect,
            headerFilterLiveFilter: false,
            formatter: (cell) => {
              const status = cell.getValue()
              const data = ('getData' in cell) ? cell.getData() : {}
              const mfinCommented = ('getData' in cell) ? data.mfinCommented : 0
              const phase = ('getData' in cell) ? data.phase : 0
              const isConclusionReportDocumentDelayed = data.isConclusionReportDocumentDelayed
              const isOnList = this.isOnList(data)
              let label = ''

              if (status === 4 && mfinCommented === 1) {
                label = this.successLabel(this.$t('projects.phaseStatuses.' + status))
              } else if (status === 4 && mfinCommented === 0 && phase !== 11) {
                label = this.errorLabel(this.$t('projects.phaseStatuses.' + status))
              } else if (status === 9 || status === 11) {
                label = this.errorLabel(this.$t('projects.phaseStatuses.' + status))
              } else if (status === 25) {
                label = this.notificationLabel(this.$t('projects.phaseStatuses.' + status))
              } else if (status === 18) {
                label = this.warningLabel(this.$t('projects.phaseStatuses.' + status))
              }
              label = this.infoLabel(this.$t('projects.phaseStatuses.' + status))
              return `${label} ${this.GetIsOnListHtml(isOnList)} ${this.GetIsConclusionReportDocumentDelayedHtml(isConclusionReportDocumentDelayed)}`
            },
            headerFilterEmptyCheck: (value) => {
              return value === '0'
            },
            headerFilterParams: {
              values: [
                { text: this.$t('projects.phaseStatuses.1'), value: 1 },
                { text: this.$t('projects.phaseStatuses.2'), value: 2 },
                { text: this.$t('projects.phaseStatuses.3'), value: 3 },
                { text: this.$t('projects.phaseStatuses.4'), value: 4 },
                { text: this.$t('projects.phaseStatuses.5'), value: 5 },
                { text: this.$t('projects.phaseStatuses.6'), value: 6 },
                { text: this.$t('projects.phaseStatuses.7'), value: 7 },
                { text: this.$t('projects.phaseStatuses.8'), value: 8 },
                { text: this.$t('projects.phaseStatuses.9'), value: 9 },
                { text: this.$t('projects.phaseStatuses.10'), value: 10 },
                { text: this.$t('projects.phaseStatuses.11'), value: 11 },
                { text: this.$t('projects.phaseStatuses.12'), value: 12 },
                { text: this.$t('projects.phaseStatuses.13'), value: 13 },
                { text: this.$t('projects.phaseStatuses.14'), value: 14 },
                { text: this.$t('projects.phaseStatuses.15'), value: 15 },
                { text: this.$t('projects.phaseStatuses.16'), value: 16 },
                { text: this.$t('projects.phaseStatuses.17'), value: 17 },
                { text: this.$t('projects.phaseStatuses.18'), value: 18 },
                { text: this.$t('projects.phaseStatuses.19'), value: 19 },
                { text: this.$t('projects.phaseStatuses.20'), value: 20 },
                { text: this.$t('projects.phaseStatuses.21'), value: 21 },
                { text: this.$t('projects.phaseStatuses.22'), value: 22 },
                { text: this.$t('projects.phaseStatuses.23'), value: 23 },
                { text: this.$t('projects.phaseStatuses.24'), value: 24 },
                { text: this.$t('projects.phaseStatuses.25'), value: 25 }
              ]
            }
          },
          {
            title: this.$t('projects.lastChangedDate'),
            hozAlign: 'center',
            field: 'lastChangeDate',
            tooltip: (cell) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('general.undefined')
            },
            sorter: 'date',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? this.formatShortDate(cell.getValue()) : this.$t('general.undefined')
            },
            headerFilter: this.vDateRange,
            headerFilterParams: { isRange: true },
            headerFilterLiveFilter: false
          },
          {
            title: this.$t('projects.lastReporting'),
            field: 'lastReporting',
            headerSort: true,
            // headerFilterPlaceholder: this.$t('tabulator.headerFilters.default'),
            // headerFilter: this.vTextFieldFilter,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            formatter: (cell) => {
              return cell.getValue() ? cell.getValue() : this.$t('general.undefined')
            }
          },
          {
            title: this.$t('projects.totalValue'),
            field: 'totalValue',
            headerSort: true,
            headerFilterLiveFilter: false,
            hozAlign: 'center',
            formatter: (cell) => {
              if (cell.getValue() === null) {
                return this.$t('general.undefined')
              } else {
                return Number(cell.getValue()) === 0 ? 0 : new Intl.NumberFormat('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(cell.getValue()).toFixed(2))
              }
            }
          }
        ],
        rowClick: (e, row) => {
          const projectURL = '/projects-archived/' + row.getData().code + '/details'
          this.handleRowClickNavigation(e, projectURL)
        }
      }
    }
  },
  mounted () {
    this.tabulatorInstance.setData(Vue.$config.api_root + '/' + Vue.$apiConfig.pagedProjectsGet + '/' + this.GetArchivedStatus())
  },
  computed: {
    canCreateProject () {
      return hasAdminClaim() || hasProjectManageClaim()
    },
    displayFinishedProjects: {
      get () {
        return dataTablesStore.getters.displayFinishedProjects
      },
      set (value) {
        dataTablesStore.dispatch('toggleDisplayFinishProjects', value)
      }
    },
    isMei () {
      return hasMeiClaim()
    },
    displayMeiButton () {
      return hasMeiClaim()
    }
  },
  methods: {
    isOnList (data) {
      return (data.identificationList || data.ideaList || data.preparednessList) || data.phase !== 3
    },
    FilterProjects (value) {
      this.displayFinishedProjects = value
      this.tabulatorInstance.setData(Vue.$config.api_root + '/' + Vue.$apiConfig.pagedProjectsGet + '/' + this.GetStatus())
    },
    GetStatus () {
      return this.displayFinishedProjects ? this.projectStatus.FINISHED : this.projectStatus.ACTIVE
    },
    GetArchivedStatus () {
      return this.projectStatus.ARCHIVED
    },
    downloadReport (reportType, format) {
      this.pageLoader = true
      this.$http.get(Vue.$apiConfig.generateBoardReportsGet + '/' + reportType + '/?reportFormat=' + format, { responseType: 'blob' })
        .then(
          response => {
            var headers = response.headers
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, reportType + '.' + format)
            this.pageLoader = false
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    GetIsOnListHtml (isOnList) {
      return isOnList ? '' : '<small class="d-inline-flex flex-row align-start text-center warning--status"><b>!</b></small>'
    },
    GetIsConclusionReportDocumentDelayedHtml (isConclusionReportDocumentDelayed) {
      return !isConclusionReportDocumentDelayed ? '' : '<small class="d-inline-flex flex-row align-start text-center warning--status"><b>' + this.$t('errors.missingConclusionReport') + '</b></small>'
    }
  }
}
</script>
